import axios from "@/util/axios";

const cartUrl = `api/shopping/cart/`;

const getCacheBuster = () => Date.now().toString();

export const fetchCart = async () => {
  try {
    const response = await axios.get(`${cartUrl}?_=${getCacheBuster()}`);
    return response.data;
  } catch (err) {
    err.response = null;
    throw err;
  }
};

export const addCartPosition = async (position) => {
  try {
    const response = await axios.post(`${cartUrl}/positions/`, position);
    return response.data;
  } catch (err) {
    err.response = null;
    throw err;
  }
};

export const deleteCartPosition = async (positionId) => {
  try {
    const response = await axios.delete(`${cartUrl}/positions/${encodeURIComponent(positionId)}`);
    return response.data;
  } catch (err) {
    err.response = null;
    throw err;
  }
};

export const patchCartPosition = async (positionId, positionPatch) => {
  try {
    const response = await axios.patch(`${cartUrl}/positions/${encodeURIComponent(positionId)}`, positionPatch);
    return response.data;
  } catch (err) {
    err.response = null;
    throw err;
  }
};
